import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnnuityItemsViewModel } from '../../../../../models/annuity-view.model';
import { DickerSelectListItem } from '../../../../../models/csp.model';
import { Subject } from 'rxjs';
import { ManageService } from '../../../../../services/manage.service';
import { CommonService } from '../../../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-cirrus-subscription',
  templateUrl: './add-cirrus-subscription.component.html',
  styleUrls: ['./add-cirrus-subscription.component.css']
})
export class AddCirrusSubscriptionComponent implements OnInit, OnDestroy {
  title: string = "Add Cirrus Subscriptions"
  searchAnnuity: string;
  annuityItemsFilter: AnnuityItemsViewModel[];
  totalPriceChange: number;
  activeTotal: number;
  pendingTotal: number;
  annuityItemsPendingList: AnnuityItemsViewModel[] = [];
  cspItemList: DickerSelectListItem[];
  annuityItems: AnnuityItemsViewModel[];
  loadContent: boolean = false;
  tenantId: string;
  setFullWindow: boolean = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private manageService: ManageService,
    private cs: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.loadContent = false;
    $('#levelOne').animate({ scrollLeft: $('#managecirrus').width() + 505 }, 400);
    this.manageService.currentPendingCirrusSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: AnnuityItemsViewModel[]) => {
      this.annuityItemsPendingList = res;
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.tenantId = url[1].path;
      this.manageService.GetCirrusItems("570S").subscribe((res: AnnuityItemsViewModel[]) => {
        this.annuityItems = res;
        this.annuityItems.forEach(item => {
          item.quantity = "1";
          item.minMaxQtyText = "";
          if (item.minQty) {
            item.minMaxQtyText += "Min Order Qty - " + this.cs.toInteger(item.minQty.replace(',', '')).toString() + " ";
            item.quantity = this.cs.toInteger(item.minQty.replace(',', '')).toString();
          }
          if (item.maxQty) {
            item.minMaxQtyText += "Max Order Qty - " + this.cs.toInteger(item.maxQty.replace(',', '')).toString() + " ";
          }
        });
        this.annuityItemsFilter = this.annuityItems;
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  changeQty(annuityItem: AnnuityItemsViewModel, idx: number): void {
    if (!annuityItem.quantity) {
      annuityItem.quantity = "1";
    }
    else {
      if (annuityItem.minQty) {
        if (this.cs.toInteger(annuityItem.quantity) < this.cs.toInteger(annuityItem.minQty.replace(',', ''))) {
          // this.commonService.showValidator(`.${idx}qty`, "Minimum qty for this item is " + toInteger(annuityItem.minQty.replace(',', '')).toString(), "right", "error");
          this.cs.implementToast("Minimum qty for this item is " + this.cs.toInteger(annuityItem.minQty.replace(',', '')).toString(), "Error");
          annuityItem.quantity = this.cs.toInteger(annuityItem.minQty.replace(',', '')).toString();
        }
      }
      if (annuityItem.maxQty) {
        if (this.cs.toInteger(annuityItem.quantity) > this.cs.toInteger(annuityItem.maxQty.replace(',', ''))) {
          // this.commonService.showValidator(`.${idx}qty`, "Maximum qty for this item is " + toInteger(annuityItem.maxQty.replace(',', '')).toString(), "right", "error");
          this.cs.implementToast("Maximum qty for this item is " + this.cs.toInteger(annuityItem.maxQty.replace(',', '')).toString(), "Error");
          annuityItem.quantity = this.cs.toInteger(annuityItem.maxQty.replace(',', '')).toString();
        }
      }
    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  filterAnnuityItems(): void {
    this.annuityItemsFilter = this.annuityItems.filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchAnnuity.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchAnnuity.toLowerCase()));
  }

  AddAnnuityItem(annuityItem: AnnuityItemsViewModel): void {
    this.loadContent = false;
    if (!this.annuityItemsPendingList.filter(item => item.stockCode == annuityItem.stockCode).length) {
      const addedItem = Object.create(annuityItem);
      annuityItem.totalPrice = this.cs.toNumber(addedItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(addedItem.quantity);
      this.annuityItemsPendingList.push(addedItem);
    } else {
      this.annuityItemsPendingList.filter(item => item.stockCode == annuityItem.stockCode)[0].quantity = (this.cs.toNumber(this.annuityItemsPendingList.filter(item => item.stockCode == annuityItem.stockCode)[0].quantity) + this.cs.toNumber(annuityItem.quantity)).toString();
      this.annuityItemsPendingList.filter(item => item.stockCode == annuityItem.stockCode)[0].totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
    }
    this.loadContent = true;
    // this.commonService.showSuccess("#" + annuityItem.stockCode, "New Item added", "right");
    this.manageService.monitorPendingCirrusSubscriptions(this.annuityItemsPendingList);
    this.cs.implementToast("New Item added", "Success");
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, "text/html").documentElement.innerHTML;
  }

  finishAddSubscriptions(): void {
    this.router.navigateByUrl("/manageSubscriptions/Cirrus/CirrusDetails/" + this.tenantId);
  }

  close() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
    $("#levelOne").animate({ scrollLeft: 250 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
